import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

// 查询产业信息服务
export function getInfos(param) {
  const url = handlerGetUrlParams('/bus/tech_push/list', param)
  return request({
    url,
    method: 'GET'
  })
}
// 新增产业服务信息
export function addInfo(data) {
  return request({
    url: '/bus/tech_push',
    method: 'POST',
    data
  })
}

// 获取产业服务信息详情
export function getDetail(id) {
  return request({
    url: `/bus/tech_push/${id}`,
    method: 'GET'
  })
}

// 编辑产业服务信息详情
export function editInfos(data) {
  return request({
    url: '/bus/tech_push',
    method: 'PUT',
    data
  })
}
// 发布产业服务信息公告
export function editStatusInfo(data) {
  return request({
    url: '/bus/tech_push/updateStatus',
    method: 'POST',
    data
  })
}
// 删除公告
export function deleteInfos(ids) {
  return request({
    url: `/bus/tech_push/${ids}`,
    method: 'DELETE'
  })
}
